import type { CardHooks } from "./registry";

/**
 * Concussion Ring — opponent can only draw 1 extra card per round.
 * Implementation: sets a flag on opponent; the draw step honors it.
 * Stubbed here — the draw step in the engine would consult opponent's
 * persistent buffs for "draw-cap".
 */
export const concussionRing: CardHooks = {
  onEnter: (ctx) => ({
    opponentPatch: {
      pendingBuffs: [
        ...ctx.opponent.pendingBuffs,
        {
          id: `cr_${Math.random().toString(36).slice(2, 9)}`,
          sourceCardName: "Concussion Ring",
          trigger: "permanent",
          effect: { kind: "draw-cap", amount: 1 },
          createdRound: ctx.game.round,
        },
      ],
    },
    log: ["Concussion Ring — opponent draw cap +1/round"],
  }),
};
